import React from 'react';
import './Home.css';

// Add tile at the end of a quick-access section (e.g. "Neues Wiki"): same size as SmallHomeOption, dashed
// outline, no chevron — a button that opens a dialog instead of a link.
function SmallHomeAddOption({ icon = 'add', text = '', onClick, disabled = false, title }) {
  return (
    <button
      type="button"
      className="homeQuickItem homeQuickAddItem"
      onClick={onClick}
      disabled={disabled}
      title={title}
    >
      <span className="homeQuickItemIconWrapper">
        <span className="material-symbols-rounded homeQuickItemIcon" aria-hidden="true">{icon}</span>
      </span>
      <span className="homeQuickItemText">{text}</span>
    </button>
  );
}

export default SmallHomeAddOption;
